<script setup lang="ts">
import { EvmTrxDetailInfo } from '~/api/repository'
import { useFetchTransactionDetail } from '~/api/service/transaction/[txnHash]/index.service'
import { transactionDetailPageType } from '~/routes/transactions'
import { ITab } from '~/types/tab.type'
import BcTabs from '~/ui/Tabs/BcTabs.vue'
import TRXTP = EvmTrxDetailInfo.TRXTP;

const route = useRoute()
const txnHash = route.params.txnHash as string

const { data } = useFetchTransactionDetail(txnHash)

type ITransactionTab = ITab<transactionDetailPageType> & {
  activeTypeList: Array<TRXTP>
}

const tabList = computed(() => {
  const tabs: Array<ITransactionTab> = [
    {
      value: 'transaction',
      label: 'Transactions',
      activeTypeList: [ TRXTP.NORMAL, TRXTP.INTERNAL, TRXTP.PENDING ],
    },
    {
      value: 'block',
      label: 'Block',
      activeTypeList: [ TRXTP.NORMAL, TRXTP.INTERNAL, TRXTP.PENDING ],
    },
    {
      value: 'internal-trace',
      label: 'Internal Trace',
      activeTypeList: [ TRXTP.INTERNAL ],
    },
    {
      value: 'logs',
      label: 'Logs',
      activeTypeList: [ TRXTP.NORMAL, TRXTP.INTERNAL, TRXTP.PENDING ],
    }
  ]
  return tabs.filter((tab: ITransactionTab) => tab.activeTypeList.includes(data.value?.TRXTP || TRXTP.NORMAL))
})

const tab = ref(route.path.split('/').at(-1) as transactionDetailPageType || transactionDetailPageType.transaction)

const router = useRouter()
watch(tab, () => {
  router.replace(routes.getTransactionDetailPageWithTab(txnHash, tab.value))
})
</script>

<template>
  <BcTabs
    v-model="tab"
    :list="tabList"
  />
</template>

<style scoped>

</style>